import React from "react";

export const UiValidationMessage = (props) => {
  return (
    <>
      <div className="df-inp-validations df-validation-message">
        <p>{props.message}</p>
      </div>
    </>
  );
};
